import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import SendIcon from 'static/images/chat/sendMessage.svg';

function ChatWindowFooter({
  ticket,
  textAreaRef,
  handleSendMessage
}) {
  const ticketIsClosed = useMemo(() => ticket?.get?.('status') === 'CLOSED',
    [ticket?.get?.('status')]);

  function handleEvent(e) {
    if (e.keyCode === 13) {
      e.preventDefault();

      !ticketIsClosed && handleSendMessage();
    }
  }

  return (
    <div className="chatFooter">
      <div className="inputContainer">
        <textarea
          ref={textAreaRef}
          placeholder={Monet.I18n.getResourcesByKey('Greenmile.Chat.TextArea.Placeholder')}
          onKeyDown={(e) => handleEvent(e)}
          disabled={ticketIsClosed}
        />
      </div>
      <div className="sendMessageAction">
        <button
          type="button"
          onClick={() => !ticketIsClosed && handleSendMessage()}
        >
          <img src={SendIcon} alt="Send Message Icon" />
        </button>
      </div>
    </div>
  );
}

ChatWindowFooter.propTypes = {
  ticket: PropTypes.object,
  textAreaRef: PropTypes.object.isRequired,
  handleSendMessage: PropTypes.func.isRequired
};

ChatWindowFooter.defaultProps = {
  ticket: {}
};

export default ChatWindowFooter;
